module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-en-69b14313574baf7b822884106b99ee27.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-en.svg
// module id = /X0J
// module chunks = 3 9